module.exports = __webpack_public_path__ + "static/assets/b825482327b3a30eff94a36296193d78.png";